<template>
  <transition name="el-zoom-in-left"> 
  <!-- <transition name="el-fade-in-linear">  -->
  <div  v-show="show" class="bigbox clearfix">
    <div class="container" id="contain">
      <div class="top" id="">
        <!-- search start -->
        <el-form :inline="true" class="demo-form-inline clearfix">
          <el-form-item label="订单编号：" class="tinp">
            <el-input v-model="vbillcode" placeholder="请输入订单编号" suffix-icon="el-icon-search" clearable ></el-input>
          </el-form-item>
          <!--  <el-form-item label="请购时间：" class="tinp searchtime" :class="{iconshow:showicon}">
           <el-date-picker  value-format="yyyy-MM-dd" v-model="time" type="date" placeholder="选择日期" @change="onParamChange"  @mouseover.native="cleandataicon" @mouseout.native="cleandataicon" >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="请购人：" class="tinp">
            <el-input v-model="creatorname" placeholder="请输入申请人" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
        </el-form-item> -->
          <el-button type="primary" class="" size="small" icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" @click="onParamChange">搜索</el-button>
          <!--  <el-button type="warning" style="margin-right: 20px" class="fr" size="small" v-loading.fullscreen.lock="fullscreenLoading" icon="el-icon-refresh" @click="shuaxin">刷新</el-button> -->
          <!-- search end -->
        </el-form>
      </div>
      <!-- :style="{'width': width}" -->
      <div class="order-list-table"  v-if="count > 0">
        <table v-for="(data,index) in goodsList" v-if="data.productList.length>=1" class="downtablelist bigtablelist">
          <tr>
            <th :id="data.vbillcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(data,index)">
              <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':data.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i>
            </th>
            <!-- <th class="allckeck" style="width:3rem" v-show="data.listshow =='N'">
              <div class="item-all-check">
                <span  class="checkbox-btn item-check-btn" v-bind:class="{'checked':data.allchecked=='Y'}" @click="toggleCheckAll(data,index)">
                   <span class="iconfont icon-duigou gou" style="font-size: 12px"></span>
                </span>
              </div>
            </th> -->
            <th colspan="10" class="thbox" style="padding:0 10px">
              <span class="toptitle fl">采购订单号：{{data.vbillcode}}</span>
              <!-- <span class="toptitle fl">快递公司：{{data.couriername}}</span> -->
              <!-- <span class="toptitle fl">快递单号：{{data.couriernumber}}</span> -->
              <span class="toptitle fl">发货日期：{{data.creationtime}}</span>
              <!-- <span class="toptitle fl">到货单号：{{data.arrivalCode}}</span> -->
              <!-- <span class="toptitle fl" style="margin-left: 1rem">{{data.creationtime}}</span> -->
              <!-- <span class="toptitle fl">审核人：{{data.approvername}}</span> -->
              <!-- <span class="toptitle fl">单据状态：{{data.fbillstatus}}</span> -->
              <!-- <span class="toptitle fr">采购总数：{{data.ntotalastnum}}</span> -->
              <!-- <span class="toptitle fr">合计：{{data.ntotalorigmny|currency('￥')}}</span> -->
              <!-- <span class="toptitle fr">采购人：{{data.billmakername}}</span> -->
              <!-- <span class="toptitle fr" v-if="data.modifiername!=''&&data.modifiername!=null">最后修改人：{{data.modifiername}}</span> -->
            </th>
          </tr>
          <tr class="first noimg" v-show="data.listshow =='N'">
            <td bgcolor="#EFF0F4" style="border:1px solid #EFF0F4"></td>
            <!-- <td class="fir" style="color: #fff;"></td> -->
            <td style="width:120px" class="tdtitle">商品编码</td>
            <td style="width:190px" class="tdtitle">商品名称</td>
            <td style="width:72px" class="tdtitle">供方发货数</td>
            <td style="width:72px" class="tdtitle">历史入库数</td>
            <td style="width:72px" class="tdtitle">当前收货数</td>
            <!-- <td class="tdtitle" style="width:140px">收货货位</td> -->
            <!-- <td style="width:8%">单价</td> -->
            <td style="width:120px" class="tdtitle">规格</td>
            <td style="width:120px" class="tdtitle">型号</td>
            <td style="width:110px;text-align: center;padding-right: 20px !important" class="lastbut tdtitle">
              操作
            </td>
          </tr>
          <tr v-for="(item,index2) in data.productList" class="first noimg" v-show="data.listshow =='N'">
            <td bgcolor="#EFF0F4" style="border:1px solid #EFF0F4"></td>
           <!--  <td class="fir" style="color: #fff;">
              <div class="list-item-check">
                <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose(item,data,index)">
                <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                </span>
              </div> 
            </td> -->
            <!-- <td style="width:11%"><img class="titleimg" v-lazy="'../../static/img/'+item.prodcutImg" alt="" /></td> -->
            <td style="width:120px">{{ item.vvendinventorycode }}</td>
            <td style="width:190px">{{ item.vvendinventoryname }}</td>
            <td style="width:72px">{{ item.nqnum }}</td>
            <td style="width:72px">{{item.naccumstorenum == null?0:item.naccumstorenum}}</td>
            <td style="width:72px">1</td>
            <!-- <td style="width:8%">{{ item.nqtorigtaxprice|currency('￥') }}</td> -->
            <!-- <td style="width:8%">{{ item.norigtaxmny|currency('￥') }}</td> -->
           <!--  <td class="" style="width:140px"> 
                <el-input v-model="item.positionname" placeholder="选择货位" suffix-icon="el-icon-search" v-on:click.native="openselectmodel(index,index2)"></el-input> 
            </td> -->
            <td style="width:120px">规格：{{ item.wlspec }}</td>
            <td style="width:120px">型号：{{ item.wltype }}</td>
            <td style="width:110px;text-align: center;padding-right: 20px !important" class="lastbut">
              <el-button type="primary" class="" size="small" @click="handleSubmit(index,index2)">确认收货</el-button>
            </td>
          </tr>
        </table>
      </div>
      <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
        <span>暂无数据</span>
      </div>
      <!-- fenye start -->
      <div class="block" style="text-align: center;margin:20px auto ">
        <span>
          <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
            :current-page="page"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="count">
          </el-pagination>
          </span>
      </div>
      <!-- fenye end -->
    </div>
    <!-- <Modal :shouShow='shouShow'></Modal> -->
    <div class="model" v-show="shouShow">
      <div class="content">
        <div class="title">
          <span class="fl">添加收货明细</span>
          <span class="fr" @click="closemodel(1)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="tablebox shou clearfix" style="width:1100px;margin:10px auto 0;">
          <div style="width:100%">
            <table style="width:100%;margin:0">
              <tr style="height: 45px;">
                <th class="tdwidth" style="width:140px">商品编码</th>
                <th class="tdwidth" style="width:200px">商品名称</th>
                <!-- <th class="tdwidth" style="width:166px">仓库</th>  -->
                <!-- <th class="tdwidth" style="width:140px">货位</th>  -->
                <th class="tdwidth" style="width:90px">采购订单数</th>
                <th class="tdwidth" style="width:90px">供方发货数</th>
                <th class="tdwidth" style="width:90px">历史入库数</th>
                <th class="tdwidth" style="width:90px">当前入库数</th>
                <th class="tdwidth" style="width:320px">备注</th>
                <th class="tdwidth" style="width:80px">操作</th>
              </tr>
            </table>
            <div style="overflow-y: auto;overflow-x:hidden;height: auto;width:100%;max-height:206px">
              <table style="margin:0;width:100%">
                <tr v-for="(item,index) in tableData.productList" :key="item.crowno" v-if="item.checked == '1'">
                  <td class="tdwidth pronamewidth" style="width:140px">
                    <!-- <el-input  class="tabinp" v-model="item.vvendinventoryname"></el-input> -->
                    <span>{{item.vvendinventorycode}}</span>
                  </td>
                  <td class="tdwidth pronamewidth" style="width:200px">
                    <input class="tabinp" disabled="disabled" v-model="item.vvendinventoryname"></input>
                    <!-- <span>{{item.vvendinventoryname}}</span> -->
                  </td>
                  <!--  <td class="tdwidth" style="width:164px"> 
                         <span>{{item.repertoryname}}</span>
                    </td> -->
                  <!--  <td class="tdwidth" style="width:140px"> 
                        <el-input v-model="item.positionname" placeholder="选择货位" suffix-icon="el-icon-search" v-on:click.native="openselectmodel(index)"></el-input>
                         <span>{{item.positionname}}</span>
                    </td> -->
                  <td class="tdwidth" style="width:90px">
                    <span>{{item.nnum}}</span>
                  </td>
                  <td class="tdwidth" style="width:90px">
                    <span>{{item.nqnum}}</span>
                  </td>
                  <td class="tdwidth" style="width:90px">
                    <span>{{item.naccumstorenum == null?0:item.naccumstorenum}}</span>
                  </td>
                  <td class="tdwidth" style="width:90px">
                    <el-input class="tabinp" v-model="item.fixedAssetsNum" clearable></el-input>
                  </td>
                  <td class="tdwidth" style="width:320px">
                    <el-input class="tabinp" v-model="item.vbmemo" clearable></el-input>
                  </td>
                  <td style="border: 1px solid #56B8AA;width:80px">
                    <el-button type="warning" class="" size="small" @click="dellist(index)">取消</el-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <el-button type="primary" class="fr" @click="sumbittable" style="margin-top: 20px;">确认提交</el-button>
        </div>
      </div>
    </div>
    <!-- model start -->
    <div class="model selectmodel" v-show="modelShow">
      <div class="content">
        <div class="title">
          <span class="fl">选择货位</span>
          <span class="fr" @click="closemodel(2)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="selectinput">
          <el-form :inline="true" style="padding:10px">
            <el-form-item class="" style="width:100%;margin: 0 !important">
              <el-select @change="selectchange" filterable value-key="positioncode" v-model="position.positionname" clearable placeholder="请选择货位" style="width:100%;" auto-complete="off">
                <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- model end -->
    <!-- model start -->
    <div class="" v-show="fullscreenLoading"></div>
    <!-- model end -->
    <!--  <el-button type="info" v-show="showTop" icon="el-icon-arrow-up" circle id="to-top-btn" style="position:fixed;right:16px;bottom:20px;" @click="toTop"></el-button> -->
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
  </div>
  </transition> 
</template>
<style>
</style>
<script>
import { currency } from '../../utils/currency' 
import axios from 'axios'

export default {
  inject: ['reload'],
  data() {
    return {
      flag:false,
      modelFlag:false,
      msgShow:false,
      butflag:true,
      show:true,
      msg:'', 
      butmsg:'确认', 
      methodName:'', 
      utilpath: '',
      fullscreenLoading: false,
      showicon: '',
      index1: '',
      width: '',
      InterfacePath: '',
      users: '',
      shoubutindex: 0,
      widthdata: 0,
      shouShow: false,
      modelShow: false,
      query: '',
      page: 1,
      pagesize: 10,
      count: 0,
      busy: true,
      loading: false,
      vbillcode: '',
      time: '',
      creatorname: '',
      id: '',
      goodsList: [

      ],
      tableData: [],
      orderList: [],
      shouhuoList: {},
      allprice: '',
      modalConfirm: false,
      tableListindex: 0,
      position: {
        positioncode: '', //货位编码
        positionname: '', //货位名称
      },
      positionList: [],
      tableHeads: [{
          label: '收货仓库',
          key: 'repertoryname'
        },
        {
          label: '收货货位',
          key: 'positionname'
        },
        // {
        //   label: '商品名称',
        //   key: 'vvendinventoryname'
        // },
        {
          label: '采购数量',
          key: 'nnum'
        },
        {
          label: '发货数量',
          key: 'nqnum'
        },
        {
          label: '入库数量',
          key: 'nqnum'
        },
        {
          label: '实收数量',
          key: 'nsnum'
        },
        // {
        //   label: '收货人',
        //   key: 'receivename'
        // },
        {
          label: '备注',
          key: 'memo'
        }
      ],
      model1: '',
      index: '',
      indexpro: '',
      loading: true,
      showTop: false,
      step: 0
    }
  },
  components: {

  },
  watch: {
    query() {
      this.getList();
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  filters: {
    currency: currency
  },
  computed: {

  },
  destroyed() {
    sessionStorage.removeItem("shouShow");
    sessionStorage.removeItem("tableData");
    sessionStorage.removeItem("vbillcode");
    // sessionStorage.removeItem("query");
    sessionStorage.removeItem("shouList");
    this.show = false;
    // console.log("清除session");
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                // console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag = true;
                      this.methodName = 'message';
                      this.msgShow = true; 
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了'; 
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow = false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了'; 
                })
            }else if(this.methodName =='handleSubmit'){
              this.fullscreenLoading = true;
              var goodsLists=[];
              goodsLists =JSON.parse(JSON.stringify(this.goodsList[this.index]));
              goodsLists.productList=[];
              goodsLists.productList.push(this.goodsList[this.index].productList[this.tableListindex])
              var reqParams = {
                fixedAssets:JSON.stringify(goodsLists),
                storecode: this.users.storecode, 
                forderstatus: '3', //单据状态
                vbillcode: this.vbillcode, //请购单号  
                pageNum: 1, //当前页
                pageSize: this.pagesize //页面数据条数
              }
              // var reqParams = {
              //   fixedAssets:'',
              //   storecode: '', 
              //   forderstatus: '', //单据状态
              //   vbillcode: '', //请购单号  
              //   pageNum: 1, //当前页
              //   pageSize: this.pagesize //页面数据条数
              // }
              //获取数据接口 
              this.$http.post(this.utilpath + '/confirmFixedAssets', reqParams, { emulateJSON: true,_timeout:600 }).then((res) => { 
                if (res.data.status == '0') {
                  this.fullscreenLoading = false;
                  this.goodsList = res.data.resultList;
                  this.count = this.goodsList.length;
                } else if(res.data.status == '9'){
                  this.fullscreenLoading =false;
                  this.$router.push({path:'/ui/login',query:{msg:9}});
                } else {
                  this.fullscreenLoading = false; 
                  this.modelFlag = true;
                  this.msgShow = true; 
                  this.methodName = 'message';
                  this.msg = res.data.message;
                  this.butflag =false;
                  this.butmsg='知道了'; 
                }
              }, (err) => {
                this.fullscreenLoading = false; 
                this.modelFlag = true;
                this.msgShow = false;
                this.methodName = 'message';
                this.msg = '连接发送固定资产收货数据接口失败';
                this.butflag =false;
                this.butmsg='知道了'; 
              });

            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    shuaxin() {
      this.reload();
    },
    cleandataicon() { 
      // console.log("打印时间-=-=-=-" + this.time);
      if (this.time != '') {
        // console.log("打印时间-=-=-=-" + this.time);
        this.showicon = !this.showicon;
      }
      if (this.time == null) {
        this.showicon = false;
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.page=1; 
      this.getList();
      // console.log(this.pagesize);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      // console.log(this.page);
      this.getList();
    },
    dellist(index) { //删除数据
      this.$confirm('此操作将删除该条数据，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.tableData.productList.length > 1) {
          this.tableData.productList[index].checked = '0'
        }
        this.shoubutindex -= 1;
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    scrollEvent(e) {
      // this.scrollToTop();
      this.showTop = e.srcElement.scrollTop > 800 ? true : false;
      //滚动的像素+容器的高度>可滚动的总高度-20像素
      // console.log("触发滚动事件");
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 20 && this.loading) {
        this.getList(true); //加载更多
      }
    },
    toTop() {
      var idmsg = '';
      if (this.id != '') {
        idmsg = this.id;
      } else {
        idmsg = 'contain';
      }
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById(idmsg).scrollTop) / 8
      this.step = dis;
      document.getElementById(idmsg).scrollTop -= dis;
      var scroll = document.getElementById(idmsg).scrollTop;
      if (scroll > 0) {
        // console.log("回到顶部循环内" + document.getElementById(idmsg).scrollTop);
        this.step += dis
        var c = setTimeout(() => this.toTop(this.step), 16);
      } else {
        clearTimeout(c);
      }
    },
    //显示隐藏表格
    showlist(item, index) { 
      // 取反(true或false)
        this.goodsList[index].listshow = item.listshow == 'Y' ? 'N' : 'Y'; 
        this.index1 = index;
        this.id = item.vbillcode;
        this.toTop();
      // }
    },
    getpositions() {
      //获取数据接口
      var reqParam = {
        storecode: this.users.storecode,
        flag: '0'
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          // console.log("打印货位" + JSON.stringify(this.positionList));
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = true; 
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }    
      }, (err) => {
        this.fullscreenLoading = false;
        this.modelFlag = true;
        this.msgShow = false;
        this.methodName = 'message';
        this.msg = '获取货位接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });
    },
    getposition() {
      //获取数据接口
      var reqParam = {
        storecode: this.users.storecode
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          // console.log("打印货位" + JSON.stringify(this.positionList));
          sessionStorage.setItem("position",JSON.stringify(this.positionList));
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        }  else {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = true; 
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }
        // console.log("获取的JSON数据"+JSON.stringify(res.result));       
      }, (err) => {
        this.fullscreenLoading = false;
        this.modelFlag = true;
        this.msgShow = false;
        this.methodName = 'message';
        this.msg = '获取货位接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });
    },
    selectchange(value) {
      // console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
      // console.log("下拉变化事件2" + value.positioncode);
      this.goodsList[this.index].productList[this.tableListindex].positioncode = value.positioncode;
      this.goodsList[this.index].productList[this.tableListindex].positionname = value.positionname;
 
      this.modelShow = false;
      this.position = {
        positioncode: '',
        positionname: ''
      };
    },
    //确认提交收货单
    sumbittable() {
      var flag = true;
      // this.goodsList[this.index].productList.forEach((item) => {
      this.tableData.productList.forEach((item) => {
        // console.log("========================"+item.positionname);
        if (item.checked == '1' && item.nsnum === '') {
          // console.log("-=-=-=-=-=-=-=-" + item.nsnum);
          flag = false;
          return;
        }
      });
      if (!flag) {
        this.$message({
          showClose: true,
          message: '请将明细表填写完整！',
          type: 'error'
        });
      } else {

        this.fullscreenLoading = true;
        // this.shouhuoList=this.goodsList[this.index];
        // this.shouhuoList=this.tableData;
        var pram = {
          poorder: JSON.stringify(this.tableData),
          storecode: this.users.storecode,
          naccumarrvnum: 0,
          fbillstatus: '4',
          vbillcode: this.vbillcode, //请购单号
          creatorname: this.creatorname, //请购人
          time: this.time, //请购时间
          pageNum: this.page, //当前页
          pageSize: this.pagesize //页面数据条数
        }

        // console.log("_+_+_+___+_+_+_+_+__+：" + JSON.stringify(this.tableData));
        //获取数据接口 
        // this.$post("/confirmPoOrder",pram,{emulateJSON:true}).then((res) => {
        this.$http.post(this.utilpath + '/confirmPoOrder', pram, { emulateJSON: true,_timeout:600}).then((res) => {
          // this.$http.post("/ktnapi/confirmPoOrder",pram,{emulateJSON:true}).then((res) => {
          // this.$http.post(this.InterfacePath+"/confirmPoOrder",pram,{emulateJSON:true}).then((res) => { 
          if (res.data.status == '0') {
            this.fullscreenLoading = false; 
            this.$message({
              showClose: true,
              message: '收货成功！',
              type: 'succcess'
            });
            this.goodsList = res.data.resultList;
            this.count = res.data.countNum;
            this.shouShow = false;
            sessionStorage.removeItem("shouShow");
          } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
          }  else {
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow = true; 
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
          }
        }, (err) => {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = false;
          this.methodName = 'message';
          this.msg = '连接请购单接口失败';
          this.butflag =false;
          this.butmsg='知道了'; 
        });

      }
    },
    openselectmodel(index,index2) { 
      this.index = index;
      this.tableListindex = index2;
      this.modelShow = true;
    },
    //关闭弹窗
    closemodel(num) {
      if (num == 1) {
        sessionStorage.removeItem("shouShow");
        this.shouShow = false;
        this.tableData = [];
      } else {
        sessionStorage.removeItem("modelShow");
        this.modelShow = false;
      }
    },
    
    //获取数据
    getList() {
      // path = 'api/goods'
      this.fullscreenLoading = true;
      var reqParams = {
        storecode: this.users.storecode, 
        forderstatus: '3', //单据状态
        vbillcode: this.vbillcode, //请购单号  
        pageNum: this.page, //当前页
        pageSize: this.pagesize //页面数据条数
      }
      //获取数据接口
      this.$http.post(this.utilpath + '/selectFixedAssets', reqParams, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => {
        // this.$post('/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => { 
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          this.goodsList = res.data.resultList;
          this.count = res.data.countNum;
        } else if (res.data.status == '-1') {
          this.goodsList = [];
          this.fullscreenLoading = false;
          this.count = res.data.countNum;
          this.$message({
            showClose: true,
            message: '暂无数据！',
            type: 'info'
          });
        } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false; 
          this.modelFlag = true;
          this.msgShow = true; 
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
        }
      }, (err) => {
        this.fullscreenLoading = false; 
        this.modelFlag = true;
        this.msgShow = false;
        this.methodName = 'message';
        this.msg = '获取固定资产数据接口失败';
        this.butflag =false;
        this.butmsg='知道了';
      });
    },
    //初始化
    init() {
      this.width = document.documentElement.clientWidth - 220;
      this.users = JSON.parse(window.localStorage.getItem("userInfo"));
      // this.widthdata = document.documentElement.clientWidth - 254;
      // document.getElementById("top").setAttribute("width",this.widthdata+'px');
      // document.getElementById("top").style.width = this.widthdata+'px';
      var goods = JSON.parse(sessionStorage.getItem("shouList"));
      if (goods == null) {
        this.getposition();
        // this.getList();
      } else {
        this.fullscreenLoading =false
        this.goodsList = goods;
        this.vbillcode = sessionStorage.getItem("vbillcode");
        this.positionList = sessionStorage.getItem("position");
        // this.query = sessionStorage.getItem("query");
      }
      var Show1 = sessionStorage.getItem("shouShow");
      var list = JSON.parse(sessionStorage.getItem("tableData"));
      if (Show1 == null) {
        this.shouShow = false;
      } else {
        this.shouShow = Show1;
        list.forEach((item) => {
          this.tableData = [];
          this.tableData.push(item);
        });
      }
    },
    //收货弹窗显示
    handleSubmit(index,index2) {
      this.index = index;
      this.tableListindex = index2;
      // console.log("handleSubmit打印收货数据：" + JSON.stringify(this.goodsList[index]));  
      this.methodName = 'handleSubmit';
      this.modelFlag = true;
      this.butflag = true;
      this.msgShow = false;
      this.butmsg='确认';
      this.msg = '确定提交收货单？' 
    },
    //搜索框变化事件
    onParamChange() {
      sessionStorage.setItem("vbillcode", this.vbillcode);
      // sessionStorage.setItem("query",this.query);
      this.page=1;
      this.getList();
      document.getElementById("contain").scrollTop = 0;
      sessionStorage.removeItem("shouList");
      sessionStorage.setItem("shouList", JSON.stringify(this.goodsList));
    },
    // 单选点击事件
    choose(item, data, index) {
      item.checked = item.checked == "1" ? '0' : '1';
      data.productList.forEach((item) => {
        if (item.checked != '1') {
          data.allchecked = 'N';
          return;
        }
      });
      var money = 0;
      data.productList.forEach((item2) => {
        if (item2.checked == '1') {
          money += parseFloat(item2.ntaxmny);
        };
      });
      this.goodsList[index].ntotaltaxmny = money;
    },
    // 全选点击事件
    toggleCheckAll(data, index) {
      // console.log("data" + data.productList);
      data.allchecked = data.allchecked == 'N' ? 'Y' : 'N';

      data.productList.forEach((item) => {
        item.checked = data.allchecked == 'Y' ? '1' : '0';
        // console.log(item.checked + "-=-=-=-=打印选中状态-=-=-==");
      });
      var money = 0;
      data.productList.forEach((item2) => {
        if (item2.checked == '1') {
          money += parseFloat(item2.ntaxmny);
        };
      });
      this.goodsList[index].ntotaltaxmny = money;
      // console.log(data.allchecked + "-=-=-=-=打印选中状态-=-=-==");
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/receives/gudingsh.vue